export const SET_ADMIN_EDIT_SCENARIO_REQUEST = 'SET_ADMIN_EDIT_SCENARIO_REQUEST';
export const SET_ADMIN_EDIT_SCENARIO_SUCCESS = 'SET_ADMIN_EDIT_SCENARIO_SUCCESS';
export const SET_ADMIN_SCENARIO_SUCCESS = 'SET_ADMIN_SCENARIO_SUCCESS';
export const SET_ADMIN_EDIT_SCENARIO_FAILED = 'SET_ADMIN_EDIT_SCENARIO_FAILED';
export const CLEAN_ADMIN_EDIT_SCENARIO = 'CLEAN_ADMIN_EDIT_SCENARIO';
